import { ResponseRequest } from 'components/Types/GeneralTypes';
import { alertService } from 'components/Varios/alert_service'
import Cargando from 'components/Varios/Cargando';
import PDFViewer from 'components/Varios/PDFViewer';
import React, { useEffect, useMemo, useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { authenticationService } from 'services/authentication.service';
import { ObtenerFormulario107 } from './FunctionsFormulario107'
import CardFormulario107 from "components/Varios/CardFormulario107.js";

export default function Formulario107() {
    const [loading, setloading] = useState<boolean>(false)
    const [datos, setdatos] = useState<Array<any> | undefined>(undefined)
    const [loadingDatos, setloadingDatos] = useState<boolean>(false)

    function handleError() {
    }
    function handleErrorInformacion() {
        alertService.error("Ha ocurrido un inconveniente al tratar de obtener información");
    }

    async function GetInfoFormulario107() {
        setloadingDatos(true)
        var datos = await ObtenerFormulario107(handleErrorInformacion)
        setdatos(datos);
        setloadingDatos(false)
    }

    const dataFormulario107 = useMemo(() => {
        if (loadingDatos && !datos) {
            return (<Cargando />)
        }
        else if (datos) {
            return (
                <Row id="lista">
                    {datos.map((dto, index) =>
                        <CardFormulario107
                            key={(index + 1)}
                            objeto={dto}
                            token={authenticationService.currentUserValue.token}
                            number={(index + 1) + " / " + datos.length}
                        />
                    )}
                </Row>
            )
        }
        else {
            return (
                <div style={{ display: "flex" }}>
                    <span>. . .</span>
                </div>
            )
        }
    }, [datos, loadingDatos])

    useEffect(() => {
        window.location.href = "https://th.espol.edu.ec/user/informacion-laboral/pagos";
        //GetInfoFormulario107();
    }, [])

    return (
        <div className="content">
            <div className='titulo_seccion'>CONSULTA - FORMULARIO 107</div>
            {
                dataFormulario107
            }
        </div>
    )
}